import { DndProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";

import { ArtifactOptions } from "../../types";
import { Artifact } from "./Artifact";
import { MobileState } from "@/Apps/Pages/MobileResponsiveToggle/types";
import { Loading } from "@/ui/Layout/Loading";
import PureCanvas from "@/Apps/Pages/V1Editor/PureCanvas";
import { addBodyIfNone } from "@/Apps/AITools/Artifacts/PageBuilderArtifact";

export const PageBuilderArtifact = ({
  content = [],
  spec = {},
  setArtifactOptions = () => {},
}: {
  content: any[];
  spec: any;
  setArtifactOptions: (options: ArtifactOptions) => void;
}) => {
  const cancelFtn = (): void => {};
  return (
    <div>
      <Artifact
        type="page builder"
        title="Page Builder"
        // onClick={onClick}
        setArtifactOptions={() =>
          setArtifactOptions({
            isShowing: true,
            title: "Page Builder",
            type: "page builder",
            container: ({ options = {} }) => (
              <div className="h-full w-full max-w-6xl overflow-y-auto">
                {/* {JSON.stringify(options)} */}
                {/* <DndProvider backend={HTML5Backend}>
                  {!Boolean(content.length) ? (
                    <div className="p-9">
                      <Loading type="gallery" />
                    </div>
                  ) : (
                    <PureCanvas
                      content={addBodyIfNone(content)}
                      onChange={() => {}}
                      // onChange={handleChange}
                      onItemSelect={cancelFtn}
                      onSave={() => {}}
                      // onSave={handleSave}
                      disableDefaultProperties
                      setActiveAddNewTab={cancelFtn}
                      mobileState={{ type: MobileState.FULLSCREEN }}
                      setMobileState={cancelFtn}
                      onLoad={cancelFtn}
                    />
                  )}
                </DndProvider> */}
              </div>
            ),
          })
        }
      />
    </div>
  );
};
